export default "__VITE_ASSET__Cp3yieMT__"